import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { apiSlice } from './api/apiSlice';
import { userApiSlice } from './api/users/userApiSlice';
import { profileApiSlice } from './api/profiles/profileApiSlice';
import { publictionApiSlice } from './api/publications/publicationApiSlice';
import { businessRequestsApiSlice } from './api/businessRequests/businessRequestsApiSlice';
import { profileClaimApiSlice } from './api/profileClaim/profileClaimApiSlice';
import { mailApiSlice } from './api/mail/mailApiSlice';
import { articlesScraperApiSlice } from './api/articlesScraper/articlesScraperApiSlice';

const store = configureStore({
  reducer: {
    ...rootReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [userApiSlice.reducerPath]: userApiSlice.reducer,
    [profileApiSlice.reducerPath]: profileApiSlice.reducer,
    [publictionApiSlice.reducerPath]: publictionApiSlice.reducer,
    [businessRequestsApiSlice.reducerPath]: businessRequestsApiSlice.reducer,
    [profileClaimApiSlice.reducerPath]: profileClaimApiSlice.reducer,
    [mailApiSlice.reducerPath]: mailApiSlice.reducer,
    [articlesScraperApiSlice.reducerPath]: articlesScraperApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = [...getDefaultMiddleware(), apiSlice.middleware, userApiSlice.middleware, profileApiSlice.middleware, publictionApiSlice.middleware, businessRequestsApiSlice.middleware, profileClaimApiSlice.middleware, mailApiSlice.middleware, articlesScraperApiSlice.middleware];
    return middleware;
  },
});

export default store;
